module.exports = __webpack_public_path__ + "static/media/heatbliss-3.bf817569.jpg";